const Config = {
    appName: process.env.REACT_APP_NAME,
    country: process.env.REACT_APP_COUNTRY,
    api: process.env.REACT_APP_API,
    domain: process.env.REACT_APP_DOMAIN,
    currency: process.env.REACT_APP_CURRENCY,
    port: process.env.REACT_APP_PORT,
    statement_api: process.env.REACT_APP_STATEMENT_API_URL,
    socket_api: process.env.REACT_APP_SOCKET_API_URL
};

export default Config;